import * as React from 'react';
import { ProductContext } from '../widgets/product/context';
import { ProductConfig } from '@journeyapps-platform/types-accounts';

export function useProductConfig(): ProductConfig {
  return React.useContext(ProductContext);
}
